import React, { Component } from 'react'

export default class BackgroundWaves extends Component {
  render() {
    return (
      
<svg
   
   xmlns="http://www.w3.org/2000/svg"
   viewBox="0 0 6000 1500"
   style={{width:'100%'}}
   
   id="svg2"
   version="1.1"><defs
     id="defs6"><clipPath
       id="clipPath20"
       clipPathUnits="userSpaceOnUse"><path
         id="path18"
         d="M 0,5000 H 5000 V 0 H 0 Z" /></clipPath><clipPath
       id="clipPath28"
       clipPathUnits="userSpaceOnUse"><path
         id="path26"
         d="M 31.4995,4941.5 H 4968.5 V 58.4999 H 31.4995 Z" /></clipPath><clipPath
       id="clipPath32"
       clipPathUnits="userSpaceOnUse"><path
         id="path30"
         d="M 4968.5,1787.648 C 4090.544,4982.495 3212.587,3064.296 2334.531,1488.177 1566.985,109.85 799.242,-1006.854 31.5,1787.648 c 0,756.547 0,1513.094 0,2269.641 V 4941.5 C 647.084,2957.128 1383.191,3018.621 2252.38,3879.995 c 204.609,174.953 416.742,359.349 636.32,475.151 1266.065,841.684 1831.213,-1308.2 2079.8,-1894.473 v -188.351 z" /></clipPath><clipPath
       id="clipPath444"
       clipPathUnits="userSpaceOnUse"><path
         id="path442"
         d="M 31.4995,3934.92 H 4968.5 V 58.7493 H 31.4995 Z" /></clipPath></defs><g
     transform="matrix(1.3333333,0,0,-1.3333333,0,1500.0002)"
     id="g10"><g
       transform="matrix(0.93923124,0,0,1,0,-1317)"
       id="g14"><g
         clipPath="url(#clipPath20)"
         id="g16"><g
           transform="matrix(0.50863936,0,0,0.12660478,2280.0001,1886.1839)"
           id="g434"><path
             id="path436"
             transform="matrix(1.4745222,0,0,-5.9239471,-4482.5475,24594.776)"
             d="m 2293.6621,3595.8789 c -150.6214,-0.712 -327.2668,49.9218 -534.3769,181.5918 C 1404.6994,3988.4081 1081.815,4194.784 789.20898,4240.9844 496.61469,4299.5459 234.05537,4132.8828 0,3743.8477 v 434.7461 c 1013.2922,1809.4755 2026.7065,-1729.695 3040,80 816.4011,1105.9204 2232.1792,-693.364 3348.2031,317.7988 v -90.7266 c -168.5868,-107.2219 -551.7991,-470.9243 -1410.5566,-278.5625 -390.5347,79.5547 -746.1546,206.7328 -1068.4258,220.832 -322.2583,20.8831 -527.6727,123.834 -869.2207,-276.1796 -112.4096,-159.473 -329.9139,-553.9084 -746.3379,-555.877 z"
             style={{fill:'#cccccc'}} /></g><g
           transform="matrix(0.61136285,0,0,0.41973311,-19.25793,1400.1495)"
           id="g438"><g
             id="g440" /><g
             id="g452"><g
               id="g450"
               clipPath="url(#clipPath444)"><g
                 id="g448"
                 transform="translate(31.5,3226.6606)" /></g></g></g><g
           id="g1278"><g
             id="g1268" /><g
             id="g1276"><g
               clipPath="url(#clipPath444)"
               id="g1274"><g
                 transform="translate(31.5,3226.6606)"
                 id="g1272" /></g></g></g></g></g><path
       id="rect1287"
       d="M 1681.3785,887.91375 C 1120.9211,890.93366 560.43416,-516.48639 0,549.05437 V 1.5e-4 H 4500.0001 V 250.70521 C 3713.8467,1009.0774 2716.5399,-340.38593 2141.4478,489.05437 1988.095,780.65562 1834.7374,887.0874 1681.3785,887.91375 Z"
       style={{fill:'#fff'}} /><g
       id="g1316"
       transform="matrix(0.93923124,0,0,1,0,-117)"><g
         id="g1314"
         clipPath="url(#clipPath20)"><g
           id="g1292"
           transform="matrix(0.50863936,0,0,0.12660478,2280.0001,1886.1839)" /><g
           id="g1302"
           transform="matrix(0.61136285,0,0,0.41973311,-19.25793,1400.1495)"><g
             id="g1294" /><g
             id="g1300"><g
               clipPath="url(#clipPath444)"
               id="g1298"><g
                 transform="translate(31.5,3226.6606)"
                 id="g1296" /></g></g></g><g
           id="g1312"><g
             id="g1304" /><g
             id="g1310"><g
               id="g1308"
               clipPath="url(#clipPath444)"><g
                 id="g1306"
                 transform="translate(31.5,3226.6606)" /></g></g></g></g></g></g></svg>
    )
  }
}
